import { render, staticRenderFns } from "./billDetailBox.vue?vue&type=template&id=0126fd68"
import script from "./billDetailBox.vue?vue&type=script&lang=js"
export * from "./billDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports